import { render } from "./breadcrumb-forum.vue?vue&type=template&id=2aa00d91&ts=true"
import script from "./breadcrumb-forum.vue?vue&type=script&lang=ts"
export * from "./breadcrumb-forum.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__